<template>
  <v-container>
    <div class="max-width-1200">
      <form-user mode="edit" :data="form" @update="updateForm"></form-user>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-row>
            <v-col cols="6">
              <v-btn @click="cancel" color="error" outlined="outlined" large="large" min-width="160">{{ $t('buttons.cancel') }}</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="submit" color="primary" large="large" min-width="160">{{ $t('buttons.update') }}</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import FormUser from '@/components/Members/Forms/User'

export default {
  components: { FormUser },
  data () {
    return {
      form: null
    }
  },
  computed: {
    memberId () {
      return this.$route.params.id
    }
  },
  methods: {
    fetchData () {
      // fetch your member data from backend
      const data = {
        name: 'John',
        phoneNumber: '0912-345-678',
        birthday: '1960/10/10',
        email: 'john@gmail.com',
        joinDate: '1980/01/01',
        note: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
      }

      this.form = data
    },
    updateForm ({ field, value }) {
      this.form[field] = value
    },
    async submit () {
      // post data to your backend
      this.$router.push(`/members/${this.memberId}`)
    },
    cancel () {
      this.$router.push(`/members/${this.memberId}`)
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
  .max-width-1200
    max-width 1200px
    margin 0 auto
</style>
